import api, { handleApiError } from '../../api.service';
import { CreateInstituicaoEnsinoDto, ReadInstituicaoEnsinoDto, UpdateInstituicaoEnsinoDto } from '@/api.types';
import { Endpoints } from '@/shared/constants/endpoints';

export class InstituicaoEnsinoService {
  async Create(dto: CreateInstituicaoEnsinoDto): Promise<number> {
    try {
      const response = await api.post<number>(
        Endpoints.INSTITUICAO_ENSINO,
        dto,
      );
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  }

  async Enumerate(): Promise<ReadInstituicaoEnsinoDto[]> {
    try {
      const response = await api.get<ReadInstituicaoEnsinoDto[]>(
        Endpoints.INSTITUICAO_ENSINO,
      );
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  }

  async EnumeratePublic(): Promise<ReadInstituicaoEnsinoDto[]> {
    try {
      const response = await api.get<ReadInstituicaoEnsinoDto[]>(
        Endpoints.INSTITUICAO_ENSINO + '/public',
      );
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  }

  async Read(id: number): Promise<ReadInstituicaoEnsinoDto> {
    try {
      const response = await api.get<ReadInstituicaoEnsinoDto>(
        Endpoints.INSTITUICAO_ENSINO + `/${id}`,
      );
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  }

  async Update(id: number, dto: UpdateInstituicaoEnsinoDto): Promise<number> {
    try {
      const response = await api.put<number>(
        Endpoints.INSTITUICAO_ENSINO + `/${id}`,
        dto,
      );
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  }

  async Delete(id: number): Promise<number> {
    try {
      const response = await api.delete<number>(
        Endpoints.INSTITUICAO_ENSINO + `/${id}`,
      );
      return response.data;
    } catch (error) {
      handleApiError(error);
    }
  }
}
